import React, { MouseEvent, useCallback, useRef } from 'react';
import { Link, Typography } from 'common/components';
import { useIntersection } from 'common/hooks';
import { RelatedService } from 'modules/related-services';
import { createElementKey } from 'utils';
import { formatToRub } from 'utils/format';
import {
  productServicesContainer,
  productInfoServicesContainer,
  productInfoServicesTitle,
  productInfoServiceWrapper,
  productInfoServicePriceWrapper,
} from './product-services-styles';

type ProductServicesProps = {
  activeServices: RelatedService[];
  onServiceClick: (service: RelatedService, position: number) => void;
  onServiceShowEvent: ((service: RelatedService, position: number) => void) | undefined;
  prefixPrice: string | undefined;
  serviceDisclaimer?: React.ReactNode;
};

export const ProductServicesNew: React.FC<ProductServicesProps> = ({
  activeServices,
  onServiceClick,
  onServiceShowEvent,
  prefixPrice,
  serviceDisclaimer,
}) => {
  const productRef = useRef<HTMLAnchorElement[]>([]);

  const handleShowEvent  = useCallback((el: Element) => {
    if (!onServiceShowEvent) {
      return;
    }

    const position = el.getAttribute('data-position');

    if (!position) {
      return;
    }

    const numberPosition = Number(position);
    onServiceShowEvent(activeServices[numberPosition], numberPosition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeServices]);

  useIntersection(productRef, handleShowEvent);

  const handleServiceClick = (index: number) => () => {
    const service = activeServices[index];

    onServiceClick(service, index);
  };

  const handleServiceWheelClick = (index: number) => (e: MouseEvent) => {
    if (e.button === 1) {
      handleServiceClick(index);
    }
  };

  return (
    <div className={productServicesContainer}>
      <Typography  className={productInfoServicesTitle} variant="s" size="body_accent">
        Закажите услуги:
      </Typography>

      <div className={productInfoServicesContainer}>
        {activeServices.map((service, index) => (
          <Link
            className={productInfoServiceWrapper}
            data-position={index}
            href={service.serviceURL}
            onClick={handleServiceClick(index)}
            onAuxClick={handleServiceWheelClick(index)}
            key={createElementKey('product-service', index)}
            refCb={(el: HTMLAnchorElement) => {
              if (el) productRef.current[index] = el;
            }}
            title={service.title}>
            <Typography variant="s" size="body_long">
              {service.title}
            </Typography>
            <Typography className={productInfoServicePriceWrapper} variant="s" size="body_accent" as="p">
              {prefixPrice} {formatToRub(Number(service.price))} ₽
            </Typography>
          </Link>
        ))}
      </div>

      {serviceDisclaimer}
    </div>
  );
};
